import { ReactNode } from 'react';
import {
  MULTIPLE_PATTERN_ERROR_MESSAGE,
  MULTIPLE_REQUIRED_ERROR_MESSAGE,
  SINGLE_PATTERN_ERROR_MESSAGE,
  SINGLE_REQUIRED_ERROR_MESSAGE,
} from '../constants/form';
import { setDynamicPhrase } from './string';

export interface FieldValidatorValidation {
  count: number;
  isValid: boolean;
}
export interface FieldValidator<T, J = boolean> {
  label: string;
  validate: { (item: T): J };
}

export function getPatternErrorMessage<T>(
  item?: T,
  fields?: FieldValidator<T, FieldValidatorValidation>[],
): ReactNode {
  if (!fields || !item) {
    return undefined;
  }

  const patternErrorFields = fields
    .map(({ label, validate }) => ({ ...validate(item), label }))
    .filter(({ isValid }) => !isValid);

  if (!patternErrorFields?.length) {
    return undefined;
  }

  const fieldNames = (
    <b key="pattern">
      {patternErrorFields.map(({ label }) => label).join(', ')}
    </b>
  );
  const isMultipleFieldHasPatternError =
    patternErrorFields.length > 1 ||
    (patternErrorFields.length === 1 && patternErrorFields[0].count > 1);

  const errorMessage = isMultipleFieldHasPatternError
    ? setDynamicPhrase(MULTIPLE_PATTERN_ERROR_MESSAGE, fieldNames)
    : setDynamicPhrase(SINGLE_PATTERN_ERROR_MESSAGE, fieldNames);

  return <span>{errorMessage}</span>;
}

export function getRequiredErrorMessage<T>(
  item: T,
  fields?: FieldValidator<NonNullable<T>>[],
): ReactNode {
  if (!fields || !item) {
    return undefined;
  }

  const requiredFields = fields
    .filter(({ validate }) => !validate(item))
    .map(({ label }) => label);

  if (!requiredFields?.length) {
    return undefined;
  }

  const fieldNames = <b key="required">{requiredFields.join(', ')}</b>;
  const isMultipleFieldHasRequiredError = requiredFields.length > 1;

  const errorMessage = isMultipleFieldHasRequiredError
    ? setDynamicPhrase(MULTIPLE_REQUIRED_ERROR_MESSAGE, fieldNames)
    : setDynamicPhrase(SINGLE_REQUIRED_ERROR_MESSAGE, fieldNames);

  return <span>{errorMessage}</span>;
}
